import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FrameComponent } from "../../common/FrameComponent";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { getAppUri } from "./helpers";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { getListenerIdent } from "../Modals/ProfileModal/helpers";
import styles from "./styles.module.css";
import { useAppSelector } from "../../services/redux/hooks/use-selector";
import {
  selectIsProfileFilled,
  selectProfile,
} from "../Modals/ProfileModal/redux/selectors";

export const ExtraApp = () => {
  const { selectedObject } = useStorageSelectors("ai_agents_extra_app");
  const profile = useAppSelector(selectProfile);
  const isProfileFilled = useAppSelector(selectIsProfileFilled);
  const { handleOpenModal } = useAppModals();
  const { t } = useTranslation();

  const extraApp = selectedObject?.value?.extra_app_object;

  const src = useMemo(() => {
    if (!extraApp?.uri) return null;
    return getAppUri(
      extraApp.uri,
      extraApp?.withToken,
      profile,
      isProfileFilled,
    );
  }, [extraApp?.uri, extraApp?.withToken, profile, isProfileFilled]);

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={t("extra_app.no_object_message")}
        folderName={selectedObject.friendly_name}
        onClick={() =>
          handleOpenModal("manage_extra_app_modal", null, "create_extra_app")
        }
      />
    );
  }

  return (
    <div className={styles.container}>
      <FrameComponent key={`${selectedObject?.id}-${src}`} src={src ?? ""} />
    </div>
  );
};
